<app-header></app-header>
<div class="row mt-4 ml-3 mr-1">
<h3>{{displayName}}</h3></div>

<div class="row mt-1 ml-1 mr-1">
  <div class="col">
    <ngx-spinner></ngx-spinner>
    <div class="cards">
      <div *ngFor="let pn of productNomenclatures" class="card">
        <img src="{{baseUrl + pn.productName}}" class="card-img-top" alt="{{pn.productName}}"
          title="{{pn.productName}}">
        <div class="card-body">
          <h5 class="card-title">{{pn.nomenclature}}</h5>
          <p class="card-text">{{pn.title}}</p>
          <a href="specpage/{{pn.productId}}" class="stretched-link" title="{{pn.productName}}"></a>
        </div>
      </div>
    </div>
  </div>
</div>